<script>
import moment from 'moment'
export default
{
    name: 'mv-date-time-picker',

    props:
    {
        value: null,
        onlyDate: Boolean,
        onlyTime: Boolean,
        noDefault: Boolean,
    },

    computed:
    {
        startDate()
        {
            return moment().month(8).date(1).startOf('day')
        },

        endDate()
        {
            return moment().month(9).date(31).endOf('day')
        }
    },

    watch:
    {
        internalValue(val)
        {
            if (this.onlyDate)
            {
                this.$emit('change', moment(val).format('YYYY-MM-DD'))
                this.$emit('input', moment(val).format('YYYY-MM-DD'))
            } else if(this.onlyTime) {
                this.$emit('change', moment(val).format('HH:mm:ss'))
                this.$emit('input', moment(val).format('HH:mm:ss'))
            } else {
                this.$emit('change', moment(val).format('YYYY-MM-DD HH:mm:ss'))
                this.$emit('input', moment(val).format('YYYY-MM-DD HH:mm:ss'))
            }
        },

        value(value)
        {
            this.setDate()
        },
    },

    methods:
    {
        setDate()
        {
            if (this.value == null || this.value == '' || this.value == undefined || this.value == 'Invalid date')
            {
                if (!this.noDefault)
                {
                  this.control.clear()
                  this.control.viewDate(this.startDate)
                  this.internalValue = this.startDate
                } else {
                  this.control.clear()
                  this.internalValue = null
                }
            } else {
                this.control.date(this.value)
                this.internalValue = this.control.date()
            }
        }
    },

    mounted()
    {
        this.$nextTick(() => {
            let format = 'YYYY-MM-DD HH:mm'
            if (this.onlyDate)
                format = 'YYYY-MM-DD'
            if (this.onlyTime)
                format = 'HH:mm'
            const enabledDates = []
            const start = this.startDate.clone()
            const end = this.endDate.clone()
            while(start.isBefore(end))
            {
                const clone = start.clone()
                enabledDates.push(clone)
                start.add(1, 'day')
            }
            $(this.$refs.elem).datetimepicker({
                format: format,
                showTodayButton: true,
                locale: 'hu',
                sideBySide: true,
                // enabledDates: enabledDates,
                defaultDate: this.startDate,
            })
            this.control = $(this.$refs.elem).data('DateTimePicker')
            $(this.$refs.elem).on('dp.change', () => {
                if (this.control.date() != null)
                {
                    this.internalValue = this.control.date()
                }
            })
            this.setDate()
        })
    },

    data()
    {
        return {
            control: null,
            internalValue: this.value,
        }
    }

}
</script>

<template>
<div class="input-group date" ref="elem">
    <input
        type="text"
        class="form-control"
        @input="internalValue = $event.target.value"
    >
    <span class="input-group-addon">
        <i class="glyphicon glyphicon-calendar"></i>
    </span>
</div>
</template>



// WEBPACK FOOTER //
// src/components/datetimepicker.vue